<template>
  <v-card
    v-if="field.value"
    class="elevation-0"
  >
    <v-alert
      :type="alertType"
      icon="info"
      value="true"
    >
      <h4>{{ field.value }}</h4>
      <p>{{ field.info }}</p>
    </v-alert>
  </v-card>
</template>

<script>
import formField from '@/mixins/form-field'

export default {
  mixins: [formField],
  computed: {
    alertType () {
      if (!this.field.value) return 'info'
      if (this.field.value.includes('Rejected')) return 'error'
      if (this.field.value.includes('Approved')) return 'success'
      return 'info'
    },
  },
}
</script>
